"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Order = exports.OrderStatus = exports.OrderPriority = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const enums_1 = require("../../common/enums");
const customer_entity_1 = require("../customers/customer.entity");
const address_entity_1 = require("../customers/address.entity");
const user_entity_1 = require("../users/user.entity");
const order_line_item_entity_1 = require("./order-line-item.entity");
const shipment_entity_1 = require("./shipment.entity");
var OrderPriority;
(function (OrderPriority) {
    OrderPriority["FLIGHT"] = "flight";
    OrderPriority["URGENT"] = "urgent";
    OrderPriority["RAPIDO"] = "rapido";
    OrderPriority["BY_BUS"] = "by_bus";
    OrderPriority["STANDARD"] = "standard";
})(OrderPriority || (exports.OrderPriority = OrderPriority = {}));
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["DRAFT"] = "draft";
    OrderStatus["CONFIRMED"] = "confirmed";
    OrderStatus["ALLOCATED"] = "allocated";
    OrderStatus["PROCESSING"] = "processing";
    OrderStatus["COMPLETED"] = "completed";
    OrderStatus["CANCELLED"] = "cancelled";
})(OrderStatus || (exports.OrderStatus = OrderStatus = {}));
let Order = class Order {
};
exports.Order = Order;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], Order.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Index)({ unique: true }),
    (0, typeorm_1.Column)({ length: 20 }),
    tslib_1.__metadata("design:type", String)
], Order.prototype, "orderNumber", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => customer_entity_1.Customer, (c) => c.orders, { eager: false, nullable: false }),
    (0, typeorm_1.JoinColumn)({ name: 'customerId' }),
    tslib_1.__metadata("design:type", typeof (_a = typeof customer_entity_1.Customer !== "undefined" && customer_entity_1.Customer) === "function" ? _a : Object)
], Order.prototype, "customer", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'customerId' }),
    tslib_1.__metadata("design:type", Number)
], Order.prototype, "customerId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => address_entity_1.Address, { nullable: true, eager: true }),
    (0, typeorm_1.JoinColumn)({ name: 'shippingAddressId' }),
    tslib_1.__metadata("design:type", typeof (_b = typeof address_entity_1.Address !== "undefined" && address_entity_1.Address) === "function" ? _b : Object)
], Order.prototype, "shippingAddress", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'shippingAddressId', nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Order.prototype, "shippingAddressId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => user_entity_1.User, { nullable: true }),
    (0, typeorm_1.JoinColumn)({ name: 'createdByAgentId' }),
    tslib_1.__metadata("design:type", typeof (_c = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _c : Object)
], Order.prototype, "createdByAgent", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'createdByAgentId', nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Order.prototype, "createdByAgentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: enums_1.Channel, default: enums_1.Channel.INBOUND_CALL }),
    tslib_1.__metadata("design:type", typeof (_d = typeof enums_1.Channel !== "undefined" && enums_1.Channel) === "function" ? _d : Object)
], Order.prototype, "source", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: OrderPriority, default: OrderPriority.STANDARD }),
    tslib_1.__metadata("design:type", String)
], Order.prototype, "priority", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: OrderStatus, default: OrderStatus.DRAFT }),
    tslib_1.__metadata("design:type", String)
], Order.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'decimal', precision: 10, scale: 2, default: 0 }),
    tslib_1.__metadata("design:type", Number)
], Order.prototype, "subtotal", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'decimal', precision: 10, scale: 2, default: 0 }),
    tslib_1.__metadata("design:type", Number)
], Order.prototype, "shippingCharges", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'decimal', precision: 10, scale: 2, default: 0 }),
    tslib_1.__metadata("design:type", Number)
], Order.prototype, "totalAmount", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], Order.prototype, "notes", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], Order.prototype, "allocatedToLogisticsAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object)
], Order.prototype, "completedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => order_line_item_entity_1.OrderLineItem, (li) => li.order, { cascade: true, eager: true }),
    tslib_1.__metadata("design:type", Array)
], Order.prototype, "lineItems", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => shipment_entity_1.Shipment, (shipment) => shipment.order),
    tslib_1.__metadata("design:type", Array)
], Order.prototype, "shipments", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_g = typeof Date !== "undefined" && Date) === "function" ? _g : Object)
], Order.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_h = typeof Date !== "undefined" && Date) === "function" ? _h : Object)
], Order.prototype, "updatedAt", void 0);
exports.Order = Order = tslib_1.__decorate([
    (0, typeorm_1.Entity)('orders')
], Order);
